<div class="help-dialog">
  <div class="help-dialog-header d-flex align-items-center justify-content-between">
    <div class="help-title">How to use RTK Base Analyzer</div>
    <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="close()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="help-dialog-body">
    <div class="mb-3">
      <div class="section-title">What this tool does</div>
      <div class="text-muted">
        RTK Base Analyzer retrieves RTCM data from an external NTRIP mount point and generates a report about your RTK Base station,
        including base coordinates, protocol/hardware information, and summary statistics.
      </div>
    </div>

    <div class="mb-3">
      <div class="section-title">Before you start</div>
      <div class="text-muted">
        If you haven’t configured a mount point connection yet, click <strong>MountPoint Setup</strong> and add one.
        The settings will be saved for future use.
      </div>
    </div>

    <div class="mb-3">
      <div class="section-title">Workflow</div>
      <ol class="mb-2">
        <li>Select a mount point from <strong>Select a Mount Point</strong>.</li>
        <li>Choose an <strong>Analysis Duration</strong>.</li>
        <li>Click <strong>Analyze Now</strong> to start the analysis task in backend.</li>
        <li>Click <strong>Refresh</strong> to load the latest analysis report when it is ready.</li>
      </ol>
      <div class="text-muted">
        The report will appear under <strong>Analysis Result</strong>. If location data is available, you can view the base position on the map section.
      </div>
    </div>

    <div class="mb-1">
      <div class="section-title">Tip</div>
      <ul class="text-muted mb-0">
        <li>If you don’t see a report yet, wait a moment and click <strong>Refresh</strong> again.</li>
        <li>Please make sure the mountpoint you are analyzing is up and running.</li>
      </ul>
    </div>
  </div>
</div>


